import { useLocalization } from "@fluent/react";
import { Chip } from "@mui/material";

type Props = {
    isBusinessCritical: boolean;
    showPrefix?: boolean;
};

export const BugBusinessCriticalChip = ({ isBusinessCritical, showPrefix = false }: Props) => {
    const { l10n } = useLocalization();

    const value = isBusinessCritical
        ? l10n.getString("yes", null, "Yes")
        : l10n.getString("no", null, "No");
    const label = showPrefix
        ? `${l10n.getString("bug-report-business-critical", null, "Critical")}: ${value}`
        : value;

    return (
        <Chip
            label={label}
            color={isBusinessCritical ? "error" : "default"}
            size="small"
            variant="outlined"
        />
    );
};
